module.exports = __webpack_public_path__ + "img/logo.1427fd31.png";